// extracted by mini-css-extract-plugin
export var tosLink = "_ab-0";